export const options = [
  'Select Model',
  'Vivo V19',
  'Vivo Y50',
  'Vivo S1 Pro',
  'Vivo V17',
  'Vivo V9',
  'Vivo Z1x',
  'Vivo S1',
  'Vivo Y91',
  'Vivo z1 Pro',
  'Vivo Y17',
  'Vivo Y91i',
  'Vivo Y81',
  'Vivo V15',
  'Vivo V11 Pro',
  'Vivo V5',
  'Vivo V15 Pro',
  'Oppo F15',
  'Oppo A9 2020',
  'Oppo A5 2020',
  'Oppo Reno2',
  'Oppo F11',
  'Oppo A7',
  'Oppo A5S',
  'Oppo F9 Pro',
  'Oppo A3S',
  'Oppo F11 Pro',
  'Realme 7',
  'Realme 7 PRO',
  'Realme 6i',
  'Realme Narzo 10',
  'Realme X2',
  'Realme 6 Pro',
  'Realme 6',
  'Realme XT',
  'Realme 5 Pro',
  'Realme 5',
  'Realme 3 Pro',
  'Realme X',
  'Realme C2',
  'OnePlus 8T',
  'Oneplus 8 Pro',
  'Oneplus Nord',
  'Oneplus 8',
  'Oneplus 7T Pro',
  'Oneplus 7T',
  'Oneplus 7',
  'Oneplus 7 Pro',
  'Oneplus 6T',
  'Oneplus 6',
  'Poco M2 Pro',
  'Redmi 8A Dual',
  'Redmi 9 Prime',
  'Redmi 9A',
  'Redmi Note 9',
  'Redmi Note 9 Pro Max',
  'Redmi Note 9 Pro',
  'Poco X2',
  'Redmi Note 8 Pro',
  'Redmi Note 8',
  'Redmi 8A',
  'Mi A3',
  'Redmi 7A',
  'Redmi Note 7s',
  'Redmi K20 Pro',
  'Redmi Note 7 Pro',
  'iPhone 12',
  'iPhone 12 Mini',
  'iPhone 12 Pro Max',
  'iPhone 11 Pro',
  'iPhone 11 Pro Max',
  'iPhone SE 2020',
  'iPhone 11',
  'iPhone XS MAX',
  'iPhone XS',
  'iPhone XR',
  'iPhone X',
  'iPhone 6',
  'iPhone 7',
  'iPhone 6s',
  'Samsung Galaxy F41',
  'Samsung Galaxy M51',
  'Samsung Galaxy M01',
  'Samsung Galaxy M11',
  'Samsung Galaxy A21s',
  'Samsung Galaxy A31',
  'Samsung Galaxy A71',
  'Samsung Galaxy Note 10 Lite',
  'Samsung Galaxy M31S',
  'Samsung Galaxy A30',
  'Samsung Galaxy A51',
  'Samsung Galaxy A70',
  'Samsung Galaxy M21',
  'Samsung Galaxy M31',
]
// export const options = [
//   {
//     value: [
//       'Select Model',
//       'Vivo V19',
//       'Vivo Y50',
//       'Vivo S1 Pro',
//       'Vivo V17',
//       'Vivo V9',
//       'Vivo Z1x',
//       'Vivo S1',
//       'Vivo Y91',
//       'Vivo z1 Pro',
//       'Vivo Y17',
//       'Vivo Y91i',
//       'Vivo Y81',
//       'Vivo V15',
//       'Vivo V11 Pro',
//       'Vivo V5',
//       'Vivo V15 Pro',
//       'Oppo F15',
//       'Oppo A9 2020',
//       'Oppo A5 2020',
//       'Oppo Reno2',
//       'Oppo F11',
//       'Oppo A7',
//       'Oppo A5S',
//       'Oppo F9 Pro',
//       'Oppo A3S',
//       'Oppo F11 Pro',
//       'Realme 7',
//       'Realme 7 PRO',
//       'Realme 6i',
//       'Realme Narzo 10',
//       'Realme X2',
//       'Realme 6 Pro',
//       'Realme 6',
//       'Realme XT',
//       'Realme 5 Pro',
//       'Realme 5',
//       'Realme 3 Pro',
//       'Realme X',
//       'Realme C2',
//       'OnePlus 8T',
//       'Oneplus 8 Pro',
//       'Oneplus Nord',
//       'Oneplus 8',
//       'Oneplus 7T Pro',
//       'Oneplus 7T',
//       'Oneplus 7',
//       'Oneplus 7 Pro',
//       'Oneplus 6T',
//       'Oneplus 6',
//       'Poco M2 Pro',
//       'Redmi 8A Dual',
//       'Redmi 9 Prime',
//       'Redmi 9A',
//       'Redmi Note 9',
//       'Redmi Note 9 Pro Max',
//       'Redmi Note 9 Pro',
//       'Poco X2',
//       'Redmi Note 8 Pro',
//       'Redmi Note 8',
//       'Redmi 8A',
//       'Mi A3',
//       'Redmi 7A',
//       'Redmi Note 7s',
//       'Redmi K20 Pro',
//       'Redmi Note 7 Pro',
//       'iPhone 12',
//       'iPhone 12 Mini',
//       'iPhone 12 Pro Max',
//       'iPhone 11 Pro',
//       'iPhone 11 Pro Max',
//       'iPhone SE 2020',
//       'iPhone 11',
//       'iPhone XS MAX',
//       'iPhone XS',
//       'iPhone XR',
//       'iPhone X',
//       'iPhone 6',
//       'iPhone 7',
//       'iPhone 6s',
//       'Samsung Galaxy F41',
//       'Samsung Galaxy M51',
//       'Samsung Galaxy M01',
//       'Samsung Galaxy M11',
//       'Samsung Galaxy A21s',
//       'Samsung Galaxy A31',
//       'Samsung Galaxy A71',
//       'Samsung Galaxy Note 10 Lite',
//       'Samsung Galaxy M31S',
//       'Samsung Galaxy A30',
//       'Samsung Galaxy A51',
//       'Samsung Galaxy A70',
//       'Samsung Galaxy M21',
//       'Samsung Galaxy M31',
//     ],
//   },
// ]
